import { render, staticRenderFns } from "./editClosed.vue?vue&type=template&id=ef6699bc"
import script from "./editClosed.vue?vue&type=script&lang=js"
export * from "./editClosed.vue?vue&type=script&lang=js"
import style0 from "./editClosed.vue?vue&type=style&index=0&id=ef6699bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports